import m from "../../../../geodata/es2015/region/usa/moHigh";
window.am4geodata_region_usa_moHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/moHigh.js
// module id = null
// module chunks = 